<template>
  <div class="video-list">
    <div
      class="video"
      v-for="(item, index) in videos"
      :key="index"
      @click="detail(item.newsId)"
    >
      <a href="javascript:;">
        <div class="imgage">
          <img :src="item.coverUrl" alt />
        </div>
        <div class="video-title">{{ item.title }}</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videos: Array,
  },
  methods: {
    detail(id) {
      this.$emit("detail", id);
    },
  },
};
</script>

<style lang="less" scoped>
.video-list {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 30px;
  margin-top: 20px;
  .video {
    margin-right: 30px;
  }
  .video-title {
    width: 210px;
    text-align: center;
    color: #333333;
    font-size: 18px;
    margin-top: 24px;
    margin-bottom: 10px;
    word-break: break-all;
  }
  .imgage {
    width: 210px;
    height: 160px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>